(function () {
    'use strict';

    angular
        .module('questionnaireTemplatesEditModule')
        .controller('ODDQuestionnaireTemplateQuestionEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'questionnaireTemplate', 'questionnaireSection',
        'oddQuestion', 'oddQuestionFieldTypes'];

    function Controller($scope, $state, $window, questionnaireTemplate, questionnaireSection, oddQuestion,
                        oddQuestionFieldTypes) {

        // scroll to top of the page on init.

        $window.scrollTo(0, 0);
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;
        $scope.oddQuestionFieldTypes = oddQuestionFieldTypes;

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.questionnaireTemplateQuestion = oddQuestion;

        $scope.goToQuestionnaireTemplate = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            }, { reload: true });
        };

        $scope.goToQuestionnaireSection = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.section', {
                ODDSectionID: questionnaireSection.ODDSectionID
            }, { reload: true });
        };
        
    }
})();